export const environment = {
  production: false,
  profile: 'development',
  redirectLocal: false,
  localApi: false
};